import { render, staticRenderFns } from "./verification.vue?vue&type=template&id=2d9a87c8&scoped=true"
import script from "./verification.vue?vue&type=script&lang=js"
export * from "./verification.vue?vue&type=script&lang=js"
import style0 from "./verification.vue?vue&type=style&index=0&id=2d9a87c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9a87c8",
  null
  
)

export default component.exports